import API_URL from "./url";
import { dataFetcher } from "./dataFetcher";

export const buildParams = (obj) => {
  const params = new URLSearchParams();
  Object.entries(obj).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") params.append(k, v);
  });
  return params;
};

export const registerFetcher = {
  post: async (values) => {
    const data = await dataFetcher("post", API_URL.Register, values);
    return data;
  },

  getCode: async (values) => {
    const data = await dataFetcher(
      "post",
      API_URL.sendVerificationCode,
      values,
      true
    );
    return data;
  },

  postCode: async (values) => {
    const data = await dataFetcher(
      "post",
      API_URL.verifyVerificationCode,
      values,
      true
    );
    return data;
  },
};

export const loginFetcher = {
  post: async (values) => {
    const data = await dataFetcher("post", API_URL.Login, values);
    return data;
  },
};

export const changePasswordFetcher = {
  put: async (values) => {
    const data = await dataFetcher("put", API_URL.changePassword, values, true);
    return data;
  },
};

export const resetPasswordFetcher = {
  getCode: async (values) => {
    const data = await dataFetcher("post", API_URL.requestCode, values, true);
    return data;
  },

  post: async (values) => {
    const data = await dataFetcher("post", API_URL.resetPassword, values, true);
    return data;
  },
};

export const broadcastFetcher = {
  sendMessage: async (values) => {
    const data = await dataFetcher("post", API_URL.broadcast, values, true);
    return data;
  },
};

export const categoryFetcher = {
  get: async () => {
    const data = await dataFetcher(
      "get",
      API_URL.Categories + "?type=category"
    );
    return data;
  },

  getSub: async () => {
    const data = await dataFetcher(
      "get",
      API_URL.Categories + "?type=sub_category"
    );
    return data;
  },

  post: async (values) => {
    const data = await dataFetcher("post", API_URL.Categories, values, true);
    return data;
  },
};

export const paginate = {
  get: async (url) => {
    const data = await dataFetcher("get", url, {}, true);
    return data;
  },

  getByNumber: async (baseUrl, page = 1) => {
    const url = `${baseUrl}${baseUrl.includes("?") ? "&" : "?"}page=${page}`;
    const data = await dataFetcher("get", url, {}, true);
    return { ...data, url };
  },
};

export const socialMediaFetcher = {
  get: async (channelId) => {
    const params = buildParams({ channel: channelId });

    const data = await dataFetcher(
      "get",
      API_URL.SocialMedia + `?${params.toString()}`
    );
    return data;
  },

  post: async (value) => {
    const data = await dataFetcher("post", API_URL.SocialMedia, value, true);
    return data;
  },

  patch: async (id, value) => {
    const data = await dataFetcher(
      "patch",
      API_URL.SocialMedia + `${id}/`,
      value,
      true
    );
    return data;
  },

  delete: async (id) => {
    const data = await dataFetcher(
      "delete",
      API_URL.SocialMedia + `${id}/`,
      {},
      true
    );
    return data;
  },
};

export const tagFetcher = {
  getConfirmedTags: async () => {
    const data = await dataFetcher("get", API_URL.Tag + "?confirm=true");
    return data;
  },

  getConfirmedTopTags: async () => {
    const data = await dataFetcher("get", API_URL.topTag + "?confirm=true");
    return data;
  },

  post: async (values) => {
    const data = await dataFetcher("post", API_URL.Tag, values, true);
    return data;
  },
};

export const channelFetcher = {
  transferChannelOwnership: async (value) => {
    const data = await dataFetcher(
      "post",
      `channels/api/v1/transfer_channel_ownership/`,
      value,
      true
    );
    return data;
  },

  getRelatedChannels: async (values) => {
    const params = buildParams({
      page_size: values.pageSize,
      from_channel: values.fromChannelId,
      to_channel: values.toChannelId,
      search: values.search,
      is_hidden_for_from: values.is_hidden_for_from,
      is_hidden_for_to: values.is_hidden_for_to,
    });

    const data = await dataFetcher(
      "get",
      `channels/api/v1/relation_channels/?${params.toString()}`
    );
    return data;
  },

  searchRelatedChannels: async (value) => {
    const params = buildParams({
      search: value,
    });

    const data = await dataFetcher(
      "get",
      `channels/api/v1/relation_channels/?${params.toString()}`
    );
    return data;
  },

  postRelatedChannels: async (values) => {
    const data = await dataFetcher(
      "post",
      `channels/api/v1/relation_channels/`,
      values,
      true
    );
    return data;
  },

  patchRelatedChannels: async (relId, values) => {
    const data = await dataFetcher(
      "patch",
      `channels/api/v1/relation_channels/${relId}/`,
      values,
      true
    );
    return data;
  },

  deleteRelatedChannels: async (relId) => {
    const data = await dataFetcher(
      "delete",
      `channels/api/v1/relation_channels/${relId}/`,
      {},
      true
    );
    return data;
  },

  getConfirmedChannels: async (pageSize) => {
    const params = buildParams({
      activation: true,
      confirm_to_channel: true,
      page_size: pageSize,
    });

    const data = await dataFetcher(
      "get",
      API_URL.Channels + `?${params.toString()}`
    );
    return data;
  },

  searchChannels: async (query) => {
    const params = buildParams({
      activation: true,
      confirm_to_channel: true,
      search: query,
    });

    const data = await dataFetcher(
      "get",
      API_URL.Channels + `?${params.toString()}`
    );
    return data;
  },

  getConfirmedChannelsWithSearch: async (search, pageSize) => {
    const params = buildParams({
      activation: true,
      confirm_to_channel: true,
      search: search,
      page_size: pageSize,
    });

    const data = await dataFetcher(
      "get",
      `${API_URL.Channels}?${params.toString()}`
    );
    return data;
  },

  getUserChannels: async (ownerId) => {
    const params = buildParams({
      activation: true,
      confirm_to_channel: true,
      owner: ownerId,
    });

    const data = await dataFetcher(
      "get",
      API_URL.Channels + `?${params.toString()}`
    );
    return data;
  },

  searchUserChannels: async (ownerId, search) => {
    const params = buildParams({
      activation: true,
      confirm_to_channel: true,
      owner: ownerId,
      search: search,
    });

    const data = await dataFetcher(
      "get",
      API_URL.Channels + `?${params.toString()}`
    );
    return data;
  },

  getEachChannel: async (id) => {
    const data = await dataFetcher("get", API_URL.Channels + `${id}/`);
    return data;
  },

  getChannelsVideos: async ({ id, page_size, search }) => {
    const params = buildParams({
      status: true,
      confirm_to_post: true,
      channel: id,
      page_size: page_size,
      search: search,
    });

    const data = await dataFetcher(
      "get",
      API_URL.Videos + `?${params.toString()}`
    );
    return data;
  },

  delete: async (id) => {
    const data = await dataFetcher(
      "delete",
      API_URL.Channels + `${id}/`,
      {},
      true
    );
    return data;
  },

  post: async (value) => {
    const data = await dataFetcher("post", API_URL.Channels, value, true);
    return data;
  },

  adminsChannels: async (adminId) => {
    const params = buildParams({
      admin: adminId,
    });

    const data = await dataFetcher(
      "get",
      API_URL.ChannelAdmin + `?${params.toString()}`
    );
    return data;
  },

  channelDescriptionEdit: async (value, id) => {
    const data = await dataFetcher(
      "put",
      `channels/api/v1/channels_edit_body/${id}/`,
      value,
      true
    );
    return data;
  },

  channelAvatarEdit: async (value, id) => {
    const data = await dataFetcher(
      "put",
      `channels/api/v1/channels_edit_avatar/${id}/`,
      value,
      true
    );
    return data;
  },

  channelBannerEdit: async (value, id) => {
    const data = await dataFetcher(
      "put",
      `channels/api/v1/channels_edit_baner/${id}/`,
      value,
      true
    );
    return data;
  },

  favoriteChannels: async () => {
    const data = await dataFetcher(
      "get",
      `channels/api/v1/channels/?is_favorite=true`,
      {}
    );
    return data;
  },

  isChannelsOwnerOrAdmin: async (channelId, userId) => {
    const params = buildParams({
      user: userId,
      channel: channelId,
    });

    const data = await dataFetcher(
      "get",
      `channels/api/v1/check_channel_owner_or_admin/?${params.toString()}`,
      {}
    );
    return data;
  },
};

export const videoFetcher = {
  postShare: async (postId) => {
    const data = await dataFetcher(
      "post",
      `channels/api/v1/video_posts/${postId}/share/`,
      {}
    );
    return data;
  },

  getConfirmedVideos: async (
    searchedText = "",
    categoryName = "",
    tagName = "",
    pageSize = ""
  ) => {
    const queryParams = buildParams({
      status: true,
      confirm_to_post: true,
      search: searchedText,
      categorys: categoryName,
      tags: tagName,
      page_size: pageSize,
    });

    const url = `${API_URL.Videos}?${queryParams.toString()}`;

    const data = await dataFetcher("get", url);
    return data;
  },

  getEachVideo: async (id) => {
    const data = await dataFetcher("get", API_URL.Videos + `${id}/`);
    return data;
  },

  getUserVideos: async (userId) => {
    const params = buildParams({
      status: true,
      confirm_to_post: true,
      publisher: userId,
    });

    const data = await dataFetcher(
      "get",
      API_URL.Videos + `?${params.toString()}`
    );
    return data;
  },

  post: async (value, setProgress) => {
    const data = await dataFetcher(
      "post",
      API_URL.Videos,
      value,
      true,
      (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setProgress(percentCompleted);
      }
    );
    return data;
  },

  delete: async (id) => {
    const data = await dataFetcher(
      "delete",
      API_URL.Videos + `${id}/`,
      {},
      true
    );
    return data;
  },

  // put: async (value, id) => {
  //   const data = await dataFetcher(
  //     "put",
  //     API_URL.videoEdit + `${id}/`,
  //     value,
  //     true
  //   );
  //   return data;
  // },

  videoDescriptionEdit: async (value, id) => {
    const data = await dataFetcher(
      "patch",
      `channels/api/v1/video_posts_edit_body/${id}/`,
      value,
      true
    );
    return data;
  },

  videoCampaignDescriptionEdit: async (value, id) => {
    const data = await dataFetcher(
      "patch",
      `campaigns/api/v1/video_posts_campaign_edit_body/${id}/`,
      value,
      true
    );
    return data;
  },

  videoCoverEdit: async (value, id) => {
    const data = await dataFetcher(
      "patch",
      `channels/api/v1/video_posts_edit_cover/${id}/`,
      value,
      true
    );
    return data;
  },

  videoCampaignCoverEdit: async (value, id) => {
    const data = await dataFetcher(
      "patch",
      `campaigns/api/v1/video_posts_campaign_edit_cover/${id}/`,
      value,
      true
    );
    return data;
  },

  videoEdit: async (value, id) => {
    const data = await dataFetcher(
      "patch",
      `channels/api/v1/video_posts_edit_video/${id}/`,
      value,
      true
    );
    return data;
  },

  videoCanpaignEdit: async (value, id) => {
    const data = await dataFetcher(
      "patch",
      `campaigns/api/v1/video_posts_campaign_edit_video/${id}/`,
      value,
      true
    );
    return data;
  },

  videosBaseOnCategory: async (categoryId) => {
    const params = buildParams({
      status: true,
      confirm_to_post: true,
      categorys: categoryId,
    });

    const data = await dataFetcher(
      "get",
      API_URL.Videos + `?${params.toString()}`,
      {}
    );
    return data;
  },

  videosBaseOnSubCategory: async (subCategoryId) => {
    const params = buildParams({
      status: true,
      confirm_to_post: true,
      sub_categorys: subCategoryId,
    });

    const data = await dataFetcher(
      "get",
      API_URL.Videos + `?${params.toString()}`,
      {}
    );
    return data;
  },

  videosBaseOnTag: async (tagId) => {
    const params = buildParams({
      status: true,
      confirm_to_post: true,
      tags: tagId,
    });

    const data = await dataFetcher(
      "get",
      API_URL.Videos + `?${params.toString()}`,
      {}
    );
    return data;
  },

  like: async (value) => {
    const data = await dataFetcher(
      "post",
      "channels/api/v1/like_video_post/",
      value,
      true
    );
    return data;
  },

  dislike: async (value) => {
    const data = await dataFetcher(
      "post",
      "channels/api/v1/dislike_video_post/",
      value,
      true
    );
    return data;
  },

  save: async (value) => {
    const data = await dataFetcher(
      "post",
      "channels/api/v1/save_video_post/",
      value,
      true
    );
    return data;
  },

  deleteSave: async (id) => {
    const data = await dataFetcher(
      "delete",
      `channels/api/v1/save_video_post/${id}/`,
      {},
      true
    );
    return data;
  },

  savedVideos: async (userId) => {
    const params = buildParams({
      user: userId,
    });

    const data = await dataFetcher(
      "get",
      `channels/api/v1/save_video_post/?${params.toString()}`,
      {},
      true
    );
    return data;
  },

  isVideoSaved: async (videoId) => {
    const params = buildParams({
      video_post: videoId,
    });

    const data = await dataFetcher(
      "get",
      `channels/api/v1/save_video_post/?${params.toString()}`,
      {},
      true
    );
    return data;
  },

  likedVideos: async () => {
    const data = await dataFetcher(
      "get",
      "channels/api/v1/most-liked-videos/",
      {}
    );
    return data;
  },

  popular: async () => {
    const data = await dataFetcher(
      "get",
      "channels/api/v1/popular-videos/",
      {}
    );
    return data;
  },

  isVideoLiked: async (userId, videoId) => {
    const params = buildParams({ user: userId, video_post: videoId });

    const data = await dataFetcher(
      "get",
      `channels/api/v1/like_video_post/?${params.toString()}`,
      {},
      true
    );
    return data;
  },
  isVideoDisliked: async (userId, videoId) => {
    const params = buildParams({
      user: userId,
      video_post: videoId,
    });

    const data = await dataFetcher(
      "get",
      `channels/api/v1/dislike_video_post/?${params.toString()}`,
      {},
      true
    );
    return data;
  },
  isVideoSavedByUser: async (userId, videoId) => {
    const params = buildParams({
      user: userId,
      video_post: videoId,
    });

    const data = await dataFetcher(
      "get",
      `channels/api/v1/save_video_post/?${params.toString()}`,
      {},
      true
    );
    return data;
  },
  removeLike: async (Id) => {
    const data = await dataFetcher(
      "delete",
      `channels/api/v1/like_video_post/${Id}/`,
      {},
      true
    );
    return data.count;
  },
  removeDisike: async (Id) => {
    const data = await dataFetcher(
      "delete",
      `channels/api/v1/dislike_video_post/${Id}/`,
      {},
      true
    );
    return data.count;
  },
};

export const specialVideoFetcher = {
  getConfirmedVideos: async (name) => {
    const params = buildParams({
      section_name: name,
    });

    const data = await dataFetcher(
      "get",
      API_URL.SpecialVideos + `?${params.toString()}`
    );
    return data;
  },

  getEachVideo: async (id) => {
    const data = await dataFetcher("get", API_URL.Videos + `${id}/`);
    return data;
  },
};

export const messagesFetcher = {
  get: async () => {
    const data = await dataFetcher(
      "get",
      API_URL.Messages + "?page_size=10000",
      {},
      true
    );
    return data;
  },

  getUdreadMessages: async () => {
    const data = await dataFetcher(
      "get",
      API_URL.Messages + `?is_read=false`,
      {},
      true
    );
    return data;
  },

  post: async () => {
    const data = await dataFetcher(
      "post",
      API_URL.Messages + `mark_as_read/`,
      {
        message: "is read",
      },
      true
    );
    return data;
  },
};

export const profileFetcher = {
  get: async () => {
    // Add timestamp to prevent caching
    const url = API_URL.Profile + `?_=${Date.now()}`;
    const data = await dataFetcher("get", url, {}, true);
    return data;
  },

  put: async (values) => {
    const data = await dataFetcher("put", API_URL.Profile, values, true);
    return data;
  },
};

export const subscribersFetcher = {
  getUsersFollowedChannels: async (userId) => {
    const params = buildParams({
      user: userId,
    });

    const data = await dataFetcher(
      "get",
      API_URL.Subscribers + `?${params.toString()}`,
      {},
      true
    );
    return data;
  },

  subscribe: async (channelId) => {
    const data = await dataFetcher(
      "post",
      API_URL.Subscribers,
      { channel_id: channelId },
      true
    );
    return data;
  },

  unsubscribe: async (channelId) => {
    const data = await dataFetcher(
      "delete",
      API_URL.Subscribers + `${channelId}/`,
      { id: channelId },
      true
    );
    return data;
  },

  isSubscribed: async (userId, channelId) => {
    const params = buildParams({
      user: userId,
      channel: channelId,
    });

    const data = await dataFetcher(
      "get",
      API_URL.Subscribers + `?${params.toString()}`,
      {},
      true
    );
    return data;
  },

  getChannelsSubscriptions: async (channelId) => {
    const params = buildParams({
      page_size: 100000,
      channel: channelId,
    });

    const data = await dataFetcher(
      "get",
      API_URL.Subscribers + `?${params.toString()}`,
      {},
      true
    );
    return data;
  },
};

export const commentsFetcher = {
  getConfirmedComments: async (id) => {
    const params = buildParams({
      confirm_to_comment: true,
      sub_confirmed_only: true,
      video_post: id,
    });

    const data = await dataFetcher(
      "get",
      API_URL.Comments + `?${params.toString()}`,
      {},
      true
    );
    return data;
  },

  getAll: async (id) => {
    const params = buildParams({
      sub_confirmed_only: false,
      video_post: id,
    });

    const data = await dataFetcher(
      "get",
      API_URL.Comments + `?${params.toString()}`,
      {},
      true
    );
    return data;
  },

  post: async (value) => {
    const data = await dataFetcher("post", API_URL.Comments, value, true);
    return data;
  },

  delete: async (commentId) => {
    const data = await dataFetcher(
      "delete",
      API_URL.Comments + `${commentId}/`,
      {},
      true
    );
    return data;
  },

  put: async (commentId, values) => {
    const data = await dataFetcher(
      "patch",
      API_URL.Comments + `${commentId}/`,
      values,
      true
    );
    return data;
  },
};

export const recommenderFetcher = {
  get: async (id) => {
    const data = await dataFetcher("get", API_URL.Recommender + `${id}/`);
    return data;
  },
};

export const playlistFetcher = {
  get: async (id) => {
    const params = buildParams({
      channel: id,
    });

    const data = await dataFetcher(
      "get",
      API_URL.Playlist + `?${params.toString()}`
    );
    return data;
  },

  getEachPlaylist: async (id) => {
    const data = await dataFetcher("get", API_URL.Playlist + `${id}/`);
    return data;
  },

  post: async (values) => {
    const data = await dataFetcher("post", API_URL.Playlist, values, true);
    return data;
  },

  put: async (playlistId, values) => {
    const data = await dataFetcher(
      "put",
      API_URL.Playlist + `${playlistId}/`,
      values,
      true
    );
    return data;
  },

  delete: async (id) => {
    const data = await dataFetcher(
      "delete",
      API_URL.Playlist + `${id}/`,
      {},
      true
    );
    return data;
  },
};

export const historyFetcher = {
  get: async () => {
    const data = await dataFetcher("get", API_URL.history, {}, true);
    return data;
  },

  getEachVideo: async (id) => {
    const params = buildParams({
      video: id,
    });

    const data = await dataFetcher(
      "get",
      API_URL.history + `?${params.toString()}`,
      {},
      true
    );
    return data;
  },

  post: async (values) => {
    const data = await dataFetcher("post", API_URL.history, values, true);
    return data;
  },

  put: async (id, values) => {
    const data = await dataFetcher(
      "put",
      API_URL.history + `${id}/`,
      values,
      true
    );
    return data;
  },
};

export const channelAdminFetcher = {
  get: async (userId) => {
    const params = buildParams({
      channel__confirm_to_channel: true,
      channel__activation: true,
      channel__admin: userId,
    });

    const data = await dataFetcher(
      "get",
      API_URL.ChannelAdmin + `?${params.toString()}`,
      {},
      true
    );
    return data;
  },

  post: async (values) => {
    const data = await dataFetcher("post", API_URL.ChannelAdmin, values, true);
    return data;
  },
};

export const usersAllChannelsFetcher = {
  get: async (userId) => {
    const data = await dataFetcher(
      "get",
      API_URL.UsersAllChannels + `${userId}/channels/`,
      {},
      true
    );
    return data;
  },
};

export const searchFetcher = {
  get: async (value) => {
    const params = buildParams({
      search: value,
    });

    const data = await dataFetcher(
      "get",
      API_URL.search + `?${params.toString()}`,
      {},
      true
    );
    return data;
  },
};

export const infoFetcher = {
  get: async (userId) => {
    const data = await dataFetcher(
      "get",
      API_URL.allInfoForEachUser + `${userId}/general_info/`,
      {},
      true
    );
    return data;
  },
};

export const accountUpgradeFetcher = {
  post: async (userId) => {
    const params = buildParams({
      user: userId,
    });

    const data = await dataFetcher(
      "post",
      API_URL.accountUpgrade + `?${params.toString()}`,
      {},
      true
    );
    return data;
  },
  deleteRequest: async (requestId) => {
    const data = await dataFetcher(
      "delete",
      API_URL.accountUpgrade + `${requestId}`,
      {},
      true
    );
    return data;
  },
  get: async () => {
    const data = await dataFetcher(
      "get",
      API_URL.accountUpgrade + "?page_size=1000000",
      {},
      true
    );
    return data;
  },
  getUsers: async () => {
    const data = await dataFetcher(
      "get",
      API_URL.Users + "?page_size=1000000",
      {},
      true
    );
    return data;
  },
  editUsers: async (values) => {
    const data = await dataFetcher("put", API_URL.Users, values, true);
    return data;
  },
  approve: async (userId, is_approved) => {
    const data = await dataFetcher(
      "put",
      API_URL.accountUpgrade + `${userId}/`,
      {
        is_approved: is_approved,
      },
      true
    );
    return data;
  },
};

export const reportProblemFetcher = {
  post: async (value) => {
    const data = await dataFetcher("post", API_URL.reportProblem, value, true);
    return data;
  },

  get: async (pageSize, userId) => {
    const params = buildParams({
      page_size: pageSize,
      user_reporter: userId,
    });

    const data = await dataFetcher(
      "get",
      API_URL.reportProblem + `?${params.toString()}`,
      {},
      true
    );
    return data;
  },
};

export const tutorialFetcher = {
  get: async () => {
    const data = await dataFetcher("get", API_URL.tutorial, {});
    return data;
  },
};

export const boxFetcher = {
  getAll: async () => {
    const data = await dataFetcher(
      "get",
      API_URL.box + `box_management/?page_size=1000`,
      {}
    );
    return data;
  },

  get: async (boxLocId) => {
    const params = buildParams({ status: true, box_location: boxLocId });

    const data = await dataFetcher(
      "get",
      API_URL.box + `box_management/?${params.toString()}`,
      {}
    );
    return data;
  },

  post: async (value) => {
    const data = await dataFetcher(
      "post",
      API_URL.box + `box_management/`,
      value,
      true
    );
    return data;
  },

  edit: async (id, values) => {
    const data = await dataFetcher(
      "put",
      API_URL.box + `box_management/${id}/`,
      values,
      true
    );
    return data;
  },

  getBoxContent: async (sectionId) => {
    const data = await dataFetcher(
      "get",
      API_URL.content + `${sectionId}/content/`,
      {}
    );
    return data;
  },

  boxItemByHand: async (values) => {
    const data = await dataFetcher(
      "post",
      API_URL.box + `box_video_items_by_hand/`,
      values,
      true
    );
    return data;
  },

  boxItemByHandForCampaign: async (values) => {
    const data = await dataFetcher(
      "post",
      API_URL.box + `box_campaign_video_items_by_hand/`,
      values,
      true
    );
    return data;
  },

  getBoxItemByHand: async (boxId) => {
    const params = buildParams({
      box: boxId,
    });

    const data = await dataFetcher(
      "get",
      API_URL.box + `box_video_items_by_hand/?${params.toString()}`,
      {},
      true
    );
    return data;
  },

  getBoxItemByHandForCampaign: async (boxId) => {
    const params = buildParams({
      box: boxId,
    });

    const data = await dataFetcher(
      "get",
      API_URL.box + `box_campaign_video_items_by_hand/?${params.toString()}`,
      {},
      true
    );
    return data;
  },

  getAllBoxLocations: async () => {
    const data = await dataFetcher("get", API_URL.box + `location_box/`, {});
    return data;
  },

  deleteBox: async (id) => {
    const data = await dataFetcher(
      "delete",
      API_URL.box + `box_management/${id}/`,
      {},
      true
    );
    return data;
  },

  deleteVideoByHand: async (id) => {
    const data = await dataFetcher(
      "delete",
      API_URL.box + `box_video_items_by_hand/${id}/`,
      {},
      true
    );
    return data;
  },

  deleteVideoByHandForCampaign: async (id) => {
    const data = await dataFetcher(
      "delete",
      API_URL.box + `box_campaign_video_items_by_hand/${id}/`,
      {},
      true
    );
    return data;
  },
};

export const blogFetcher = {
  getAll: async () => {
    const data = await dataFetcher("get", API_URL.blog + `blog_article/`, {});
    return data;
  },

  getEachPost: async (id) => {
    const data = await dataFetcher(
      "get",
      API_URL.blog + `blog_article/${id}/`,
      {}
    );
    return data;
  },

  increaseView: async (blogId) => {
    const data = await dataFetcher(
      "get",
      API_URL.blog + `increase_blog_article_view/${blogId}/`,
      {}
    );
    return data;
  },

  getCtegories: async () => {
    const data = await dataFetcher("get", API_URL.blog + `blog_category/`, {});
    return data;
  },

  getTags: async () => {
    const data = await dataFetcher("get", API_URL.blog + `blog_tags/`, {});
    return data;
  },

  getBlogTags: async () => {
    const data = await dataFetcher(
      "get",
      API_URL.blog + `blog_article_tag/`,
      {}
    );
    return data;
  },

  getMostlyViewed: async () => {
    const data = await dataFetcher("get", API_URL.blog + `most-viewed/`, {});
    return data;
  },

  getSearch: async (value) => {
    const params = buildParams({
      search: value,
    });

    const data = await dataFetcher(
      "get",
      API_URL.blog + `blog_article/?${params.toString()}`,
      {}
    );
    return data;
  },

  getPostsByCategory: async (catId) => {
    const params = buildParams({
      category: catId,
    });

    const data = await dataFetcher(
      "get",
      API_URL.blog + `blog_article/?${params.toString()}`,
      {}
    );
    return data;
  },

  getSimilarPosts: async (postId) => {
    const data = await dataFetcher(
      "get",
      API_URL.blog + `similar-content/${postId}/`,
      {}
    );
    return data;
  },
};

export const reportFetcher = {
  get: async (start_date, end_date) => {
    const params = buildParams({
      start_date: start_date,
      end_date: end_date,
    });

    const data = await dataFetcher(
      "get",
      `channels/api/v1/supervisor_post_report/?${params.toString()}`,
      {}
    );
    return data;
  },

  getByCategory: async (start_date, end_date, catId, subCatId, tagId) => {
    const params = buildParams({
      start_date: start_date,
      end_date: end_date,
      category: catId,
      sub_category: subCatId,
      tag: tagId,
    });

    const data = await dataFetcher(
      "get",
      `channels/api/v1/supervisor_post_report/?${params.toString()}`,
      {}
    );
    return data;
  },

  getTotalData: async (start_date, end_date, catId, subCatId, tagId) => {
    const params = buildParams({
      start_date: start_date,
      end_date: end_date,
      category: catId,
      sub_category: subCatId,
      tag: tagId,
    });

    const data = await dataFetcher(
      "get",
      `channels/api/v1/supervisor_post_report_chart/?${params.toString()}`,
      {}
    );
    return data;
  },
};

export const pannelInfoFetcher = {
  getComments: async (start_date, end_date, userId) => {
    const params = buildParams({
      user_id: userId,
      start_date: start_date,
      end_date: end_date,
    });

    const data = await dataFetcher(
      "get",
      API_URL.commentReport + `?${params.toString()}`,
      {},
      true
    );
    return data;
  },

  getInteractions: async (start_date, end_date, userId) => {
    const params = buildParams({
      start_date: start_date,
      end_date: end_date,
    });

    const data = await dataFetcher(
      "get",
      `channels/api/v1/user/${userId}/intraction_info/?${params.toString()}`,
      {},
      true
    );
    return data;
  },
};

export const campaignFetcher = {
  deleteCampaignResult: async (id) => {
    const data = await dataFetcher(
      "delete",
      API_URL.campaign + `choose_result_video_campaign/${id}/`,
      {},
      true
    );
    return data;
  },

  all: async () => {
    const data = await dataFetcher(
      "get",
      API_URL.campaign + `campaign/`,
      {},
      true
    );
    return data;
  },

  getActiveCampaigns: async () => {
    const data = await dataFetcher(
      "get",
      API_URL.campaign + `campaign/?activation=true`,
      {},
      true
    );
    return data;
  },

  getUsersCampaigns: async (userId) => {
    const params = buildParams({
      owner: userId,
    });

    const data = await dataFetcher(
      "get",
      API_URL.campaign + `campaign/?${params.toString()}`,
      {},
      true
    );
    return data;
  },

  getEachCampaign: async (campaignId) => {
    const data = await dataFetcher(
      "get",
      API_URL.campaign + `campaign/${campaignId}/`,
      {}
    );
    return data;
  },

  AddVideoToCampaign: async (values, setProgress) => {
    const data = await dataFetcher(
      "post",
      API_URL.campaign + "campaign_video_posts/",
      values,
      true,
      (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setProgress(percentCompleted);
      }
    );
    return data;
  },

  getCampaignVideos: async ({
    campaignId,
    tags,
    category,
    pageSize,
    campaignName,
  }) => {
    const queryParams = buildParams({
      status: true,
      confirm_to_post: true,
      campaign: campaignId,
      tags: tags,
      category: category,
      page_size: pageSize,
      search: campaignName,
    });

    const data = await dataFetcher(
      "get",
      `${API_URL.campaign}campaign_video_posts/?${queryParams.toString()}`,
      {},
      true
    );
    return data;
  },

  getEachVideo: async (videoId) => {
    const data = await dataFetcher(
      "get",
      `campaigns/api/v1/campaign_video_posts/${videoId}/`,
      {},
      true
    );
    return data;
  },

  getNormalUsersCampaigns: async (publisherId) => {
    const params = buildParams({
      page_size: 1000000,
      publisher: publisherId,
    });

    const data = await dataFetcher(
      "get",
      `campaigns/api/v1/campaign_video_posts/?${params.toString()}`,
      {},
      true
    );
    return data;
  },

  deleteVideo: async (videoId) => {
    const data = await dataFetcher(
      "delete",
      `campaigns/api/v1/campaign_video_posts/${videoId}/`,
      {},
      true
    );
    return data;
  },

  like: async (value) => {
    const data = await dataFetcher(
      "post",
      "campaigns/api/v1/like_campaign_video_post/",
      value,
      true
    );
    return data;
  },

  dislike: async (value) => {
    const data = await dataFetcher(
      "post",
      "campaigns/api/v1/dislike_campaign_video_post/",
      value,
      true
    );
    return data;
  },

  save: async (value) => {
    const data = await dataFetcher(
      "post",
      "campaigns/api/v1/save_campaign_video_post/",
      value,
      true
    );
    return data;
  },

  deleteSave: async (id) => {
    const data = await dataFetcher(
      "delete",
      `campaigns/api/v1/save_campaign_video_post/${id}/`,
      {},
      true
    );
    return data;
  },

  isVideoLiked: async (userId, videoId) => {
    const params = buildParams({
      user: userId,
      video_post: videoId,
    });

    const data = await dataFetcher(
      "get",
      `campaigns/api/v1/like_campaign_video_post/?${params.toString()}`,
      {},
      true
    );
    return data;
  },

  isVideoDisliked: async (userId, videoId) => {
    const params = buildParams({
      user: userId,
      video_post: videoId,
    });

    const data = await dataFetcher(
      "get",
      `campaigns/api/v1/dislike_campaign_video_post/?${params.toString()}`,
      {},
      true
    );
    return data;
  },

  isVideoSaved: async (userId, videoId) => {
    const params = buildParams({
      user: userId,
      video_post: videoId,
    });

    const data = await dataFetcher(
      "get",
      `campaigns/api/v1/save_campaign_video_post/?${params.toString()}`,
      {},
      true
    );
    return data;
  },

  removeLike: async (Id) => {
    const data = await dataFetcher(
      "delete",
      `campaigns/api/v1/like_campaign_video_post/${Id}/`,
      {},
      true
    );
    return data;
  },

  removeDisike: async (Id) => {
    const data = await dataFetcher(
      "delete",
      `campaigns/api/v1/dislike_campaign_video_post/${Id}/`,
      {},
      true
    );
    return data;
  },

  subscribe: async (campaignId) => {
    const data = await dataFetcher(
      "post",
      API_URL.CampaignSubscribers,
      { campaign_id: campaignId },
      true
    );
    return data;
  },

  isSubscribed: async (userId, campaignId) => {
    const params = buildParams({
      user: userId,
      campaign: campaignId,
    });

    const data = await dataFetcher(
      "get",
      API_URL.CampaignSubscribers + `?${params.toString()}`,
      {},
      true
    );
    return data;
  },

  unsubscribe: async (campaignId) => {
    const data = await dataFetcher(
      "delete",
      API_URL.CampaignSubscribers + `${campaignId}/`,
      { id: campaignId },
      true
    );
    return data;
  },

  postCampaignComments: async (value) => {
    const data = await dataFetcher(
      "post",
      "campaigns/api/v1/comments_campaign_video_post/",
      value,
      true
    );
    return data;
  },

  getCampaignComments: async (videoId) => {
    const params = buildParams({
      confirm_to_comment: true,
      sub_confirmed_only: true,
      video_post: videoId,
    });

    const data = await dataFetcher(
      "get",
      `campaigns/api/v1/comments_campaign_video_post/?${params.toString()}`,
      {}
    );
    return data;
  },

  getRecomends: async (videoId) => {
    const data = await dataFetcher(
      "get",
      `campaigns/api/v1/recommender_campaign_videos/${videoId}/`,
      {}
    );
    return data;
  },

  post: async (value) => {
    const data = await dataFetcher(
      "post",
      API_URL.campaign + "campaign/",
      value,
      true
    );
    return data;
  },

  deleteCampaign: async (campaignId) => {
    const data = await dataFetcher(
      "delete",
      API_URL.campaign + `campaign/${campaignId}/`,
      {},
      true
    );
    return data;
  },

  getCampaignResult: async (id) => {
    const params = buildParams({
      campaign: id,
    });

    const data = await dataFetcher(
      "get",
      API_URL.campaign + `choose_result_video_campaign/?${params.toString()}`,
      {},
      true
    );
    return data;
  },

  postCampaignResult: async (values) => {
    const data = await dataFetcher(
      "post",
      API_URL.campaign + `choose_result_video_campaign/`,
      values,
      true
    );
    return data;
  },

  editCampaignResult: async (id, values) => {
    const data = await dataFetcher(
      "put",
      API_URL.campaign + `choose_result_video_campaign/${id}/`,
      values,
      true
    );
    return data;
  },

  campaignDescriptionEdit: async (value, id) => {
    const data = await dataFetcher(
      "patch",
      `campaigns/api/v1/campaigns_edit_body/${id}/`,
      value,
      true
    );
    return data;
  },

  campaignBannerEdit: async (value, id) => {
    const data = await dataFetcher(
      "patch",
      `campaigns/api/v1/campaigns_edit_baner/${id}/`,
      value,
      true
    );
    return data;
  },

  campaignBackgroundEdit: async (value, id) => {
    const data = await dataFetcher(
      "patch",
      `campaigns/api/v1/campaigns_edit_background/${id}/`,
      value,
      true
    );
    return data;
  },

  campaignRateEdit: async (value, id) => {
    const data = await dataFetcher(
      "put",
      `campaigns/api/v1/rate_the_videos/${id}/`,
      value,
      true
    );
    return data;
  },

  getCampaignsSubscriptions: async (campaignId) => {
    const params = buildParams({
      page_size: 100000,
      campaign: campaignId,
    });

    const data = await dataFetcher(
      "get",
      `campaigns/api/v1/subscriptions/?${params.toString()}`,
      {}
    );
    return data;
  },

  postShare: async (postId) => {
    const data = await dataFetcher(
      "post",
      `campaigns/api/v1/campaign_video_posts/${postId}/share/`,
      {}
    );
    return data;
  },
};

export const campaignReportFetcher = {
  get: async (start_date, end_date) => {
    const params = buildParams({
      start_date: start_date,
      end_date: end_date,
    });

    const data = await dataFetcher(
      "get",
      `campaigns/api/v1/supervisor_campaign_post_report/?${params.toString()}`,
      {}
    );
    return data;
  },

  getByCategory: async (start_date, end_date, catId, subCatId, tagId) => {
    const params = buildParams({
      start_date: start_date,
      end_date: end_date,
      category: catId,
      sub_category: subCatId,
      tag: tagId,
    });

    const data = await dataFetcher(
      "get",
      `campaigns/api/v1/supervisor_campaign_post_report/?${params.toString()}`,
      {}
    );
    return data;
  },

  getTotalData: async (start_date, end_date) => {
    const params = buildParams({
      start_date: start_date,
      end_date: end_date,
    });

    const data = await dataFetcher(
      "get",
      `campaigns/api/v1/supervisor_campaign_post_report_chart/?${params.toString()}`,
      {}
    );
    return data;
  },

  getByCategoryForChart: async (
    start_date,
    end_date,
    catId,
    subCatId,
    tagId
  ) => {
    const params = buildParams({
      start_date: start_date,
      end_date: end_date,
      category: catId,
      sub_category: subCatId,
      tag: tagId,
    });

    const data = await dataFetcher(
      "get",
      `campaigns/api/v1/supervisor_campaign_post_report_chart/?${params.toString()}`,
      {}
    );
    return data;
  },
};

export const exhibitionFetcher = {
  getFloor: async () => {
    const data = await dataFetcher(
      "get",
      API_URL.exhibition + `floor/?page_size=100000`,
      {}
    );
    return data;
  },

  getStore: async () => {
    const data = await dataFetcher(
      "get",
      API_URL.exhibition + `store/?page_size=100000`,
      {}
    );
    return data;
  },

  getExhibition: async () => {
    const data = await dataFetcher(
      "get",
      API_URL.exhibition + `exhibition/?page_size=100000`,
      {}
    );
    return data;
  },

  getEachExhibition: async (id) => {
    const data = await dataFetcher(
      "get",
      API_URL.exhibition + `exhibition/${id}/?page_size=100000`,
      {}
    );
    return data;
  },

  getExhibitionFloors: async (id) => {
    const params = buildParams({ page_size: 100000, exhibition: id });

    const data = await dataFetcher(
      "get",
      API_URL.exhibition + `floor/?${params.toString()}`,
      {}
    );
    return data;
  },

  getExhibitionEachFloor: async (exhibitionId, floorId) => {
    const params = buildParams({ page_size: 100000, exhibition: exhibitionId });

    const data = await dataFetcher(
      "get",
      API_URL.exhibition + `floor/${floorId}/?${params.toString()}`,
      {}
    );
    return data;
  },

  getFloorStores: async (floorId) => {
    const params = buildParams({ page_size: 100000, floor: floorId });

    const data = await dataFetcher(
      "get",
      API_URL.exhibition + `store/?${params.toString()}`,
      {}
    );
    return data;
  },

  postExhibition: async (values) => {
    const data = await dataFetcher(
      "post",
      API_URL.exhibition + `exhibition/`,
      values,
      true
    );
    return data;
  },

  postFloor: async (values) => {
    const data = await dataFetcher(
      "post",
      API_URL.exhibition + `floor/`,
      values,
      true
    );
    return data;
  },

  updateFloor: async (floorId, values) => {
    const data = await dataFetcher(
      "put",
      API_URL.exhibition + `floor/${floorId}/`,
      values,
      true
    );
    return data;
  },

  postStore: async (values) => {
    const data = await dataFetcher(
      "post",
      API_URL.exhibition + `store/`,
      values,
      true
    );
    return data;
  },

  updateStoreBody: async (storeId, values) => {
    const data = await dataFetcher(
      "put",
      API_URL.exhibition + `store_edit_body/${storeId}/`,
      values,
      true
    );
    return data;
  },

  updateStoreCover: async (storeId, values) => {
    const data = await dataFetcher(
      "put",
      API_URL.exhibition + `store_edit_cover/${storeId}/`,
      values,
      true
    );
    return data;
  },

  deleteStore: async (storeId) => {
    const data = await dataFetcher(
      "delete",
      API_URL.exhibition + `store/${storeId}/`,
      {},
      true
    );
    return data;
  },

  getMeetingCards: async () => {
    const data = await dataFetcher(
      "get",
      API_URL.exhibition + `specialized_meeting/?page_size=100000`,
      {},
      true
    );
    return data;
  },
};

export const repostFetcher = {
  post: async (values) => {
    const data = await dataFetcher("post", API_URL.repost, values, true);
    return data;
  },

  isVideoReposted: async (videoId) => {
    const data = await dataFetcher(
      "get",
      `channels/api/v1/video_posts/${videoId}/repost_status/`,
      {},
      true
    );
    return data;
  },
};

export const permissionFetcher = {
  getPermissions: async () => {
    const data = await dataFetcher("get", API_URL.permissions, {}, true);
    return data;
  },
};
